import { render, staticRenderFns } from "./ProjectApplyDetail.vue?vue&type=template&id=6e127e19&scoped=true&"
import script from "./ProjectApplyDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectApplyDetail.vue?vue&type=style&index=0&id=6e127e19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e127e19",
  null
  
)

export default component.exports